import { EntityBase } from './EntityBase';
import { Material } from './Material';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class DermalExposure extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   dermalExposureId: number;
   materialId: number;
   ingredientPercent: number;
   evaluator: string;
   exposure: number;
   percentile: number;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   material: Material;
}

